import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";
import Button from "../../../components/ui/Button";

const FeaturedPrograms = () => {
  const featuredPrograms = [
    {
      id: 1,
      title: "Computing Informatics & Business",
      duration: "KASNEB",
      level: "Level 4, 5, & 6",
      image:
        "/assets/images/Trainees_ICTLabSession3-min.JPG",
      description:
        "Develop advanced ICT and business competencies through a balanced blend of theory and practical training in computing, informatics, and entrepreneurship. This program equips learners with digital skills for the modern workplace and emerging tech industries.",
      highlights: [
        "Software & Web Development",
        "Networking & Cybersecurity",
        "Computer Repair and Maintenance",
        "Office Administration",
        "Supply Chain Management",
        "Entrepreneurship & Business Management",
      ],
      icon: "Code",
      color: "bg-blue-500",
    },
    {
      id: 2,
      title: "Building & Civil Engineering",
      level: "Level 4, 5, & 6",
      image:
        "/assets/images/Trainees_in_Carpentry1-min.JPG",
      description:
        "Gain hands-on skills in construction technology, structural design, surveying, and project management. This program equips learners to plan, design, and supervise civil works and building projects that shape modern infrastructure.",
      highlights: [
        "Building Technician",
        "Civil Engineering",
        "Interior Design",
        "Land Surveying",
        "Quantity Surveying",
        "Plumbing",
        "Carpentry and Joinery",
      ],
      icon: "Building2",
      color: "bg-yellow-500",
    },
    {
      id: 3,
      title: "Electrical & Electronics Engineering",
      level: "Level 4, 5 & 6",
      image:
        "/assets/images/Electrical_TraineesPractical5-min.JPG",
      description:
        "Learn the principles of electrical power systems, electronics, and automation through practical projects and laboratory training. The program prepares learners to design, install, and maintain electrical and electronic systems for industrial and domestic applications.",
      highlights: [
        "Electrical Engineering",
        "Electrical Installation",
        "Solar PV Installation",
        "Electronics Installation",
      ],

      icon: "Zap",
      color: "bg-yellow-700",
    },
    {
      id: 4,
      title: "Agriculture & Environmental Studies",
      level: "Level 4, 5 & 6",
      image:
        "/assets/images/FishPond_Farm-min.JPG",
      description:
        "Develop practical skills in sustainable agriculture, agribusiness, and environmental management. The program prepares learners to improve food production, manage natural resources, and apply modern technologies for climate-smart and eco-friendly solutions.",
      highlights: [
        "Agricultural Extension",
        "Aquaculture",
        "Apiculture Management",
        "Sustainable Agriculture & Rural Development",
      ],
      icon: "Leaf",
      color: "bg-green-500",
    },
    {
      id: 5,
      title: "Hospitality & Tourism",
      level: "Level 4, 5 & 6",
      image:
        "/assets/images/Food_Service-min.jpg",
      description:
        "Gain professional skills in hospitality operations, culinary arts, catering, and institutional management. This program equips learners to deliver quality guest services, manage hospitality establishments, and uphold high standards in food production and accommodation management.",
      highlights: [
        "Baking Technology",
        
        "Food & Bevarage Production & Service",
        "Catering & Accommodation",
        "Tour & Travel Management",
      ],

      icon: "UtensilsCrossed",
      color: "bg-blue-800",
    },
    {
      id: 6,
      title: "Cosmetology, Fashion & Design",
      level: "Level 4, 5 & 6",
      image:
        "/assets/images/Equipment1_cosmetology-min.JPG",
      description:
      "Master the art and science of beauty therapy, hairdressing, fashion design, and garment construction. This program equips learners with creative and technical skills to excel in the dynamic beauty and fashion industries.",
      highlights: [
        "Beauty Therapy",
        "Hair Dressing",
        "Fashion Design Technology",
        "Garment Construction",
        "Makeup Artistry",
        "Employment-Ready Skills Development",
      ],

      icon: "Scissors",
      color: "bg-purple-800",
    },
    {
      id: 7,
      title: "Dual TVET Training",
      level: "Level 4, 5 & 6",
      image:
        "/assets/images/Trainees_Building3-min.jpg",
      description:
        "Experience a blended learning approach that integrates classroom instruction with real-world industry training. The Dual TVET model bridges the gap between theory and practice, preparing learners with hands-on skills that meet current labor market demands.",
      highlights: [
        "Industry-Based Apprenticeships",
        "Competency-Based Training (CBET)",
        "Mentorship by Industry Experts",
        "Workplace Assessment & Certification",
        "Partnerships with Leading Companies",
        "Employment-Ready Skills Development",
      ],

      icon: "Briefcase",
      color: "bg-green-800",
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-blue-400 via-blue-700 to-yellow-400">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
            Featured Programs
          </h2>
          <p className="text-2xl text-black max-w-fit mx-auto">
            Explore our most popular technical programs designed to prepare you
            for successful careers in high-demand industries.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {featuredPrograms?.map((program) => (
            <div
              key={program?.id}
              className="bg-card rounded-xl shadow-card hover:shadow-card-lg transition-all duration-300 overflow-hidden group"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <Image
                  src={program?.image}
                  alt={program?.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <div
                    className={`${program?.color} text-white px-3 py-1 rounded-full text-lg font-medium`}
                  >
                    {program?.level}
                  </div>
                </div>
                <div className="absolute top-4 right-4">
                  <div className="bg-white/90 backdrop-blur-lg text-foreground px-3 py-1 rounded-full text-sm font-medium">
                    {program?.duration}
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center space-x-3 mb-3">
                  <div
                    className={`w-10 h-10 ${program?.color} rounded-lg flex items-center justify-center`}
                  >
                    <Icon name={program?.icon} size={20} color="white" />
                  </div>
                  <h3 className="text-xl font-bold text-foreground">
                    {program?.title}
                  </h3>
                </div>

                <p className="text-muted-foreground mb-4 leading-relaxed">
                  {program?.description}
                </p>

                {/* Highlights */}
                <div className="mb-6">
                  <h4 className="font-semibold text-foreground mb-2">
                    Key Areas:
                  </h4>
                  <div className="grid grid-cols-2 gap-2">
                    {program?.highlights?.map((highlight, index) => (
                      <div key={index} className="flex items-center space-x-2">
                        <Icon
                          name="CheckCircle"
                          size={14}
                          className="text-success"
                        />
                        <span className="text-sm text-muted-foreground">
                          {highlight}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Actions */}
                <div className="flex space-x-3">
                  <Link to="/courses" className="flex-1">
                    <Button
                      variant="default"
                      fullWidth
                      iconName="ArrowRight"
                      iconPosition="right"
                    >
                      Learn More
                    </Button>
                  </Link>
                  <Link to="/contact">
                    <Button variant="outline" iconName="Download">
                      Brochure
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Programs */}
        <div className="text-center mt-12">
          <Link to="/courses">
            <Button
              variant="outline"
              size="lg"
              iconName="BookOpen"
              iconPosition="left"
            >
              View All Programs
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPrograms;
